import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sc-video-status-icon-component',
  templateUrl: './video-status-icon.component.html',
  styleUrls: ['./video-status-icon.component.scss']
})
export class VideoStatusIconComponent implements OnInit {
  @Input() public status: number;
  @Input() public tooltip: string;

  constructor() {}

  public ngOnInit() {}
}
